import { Badge } from "@/components/ui/badge";
import { UserCheck, Mail, Clock, UserX } from "lucide-react";

export type OnboardingStatus = 'onboarded' | 'invited_pending' | 'invited_expired' | 'not_invited';

interface OnboardingStatusBadgeProps {
  status?: OnboardingStatus;
}

export const OnboardingStatusBadge = ({ status }: OnboardingStatusBadgeProps) => {
  switch (status) {
    case 'onboarded':
      return (
        <Badge className="bg-green-100 text-green-800 border-green-200 hover:bg-green-100">
          <UserCheck className="h-3 w-3 mr-1" />
          Onboarded
        </Badge>
      );
    case 'invited_pending':
      return (
        <Badge className="bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-100">
          <Mail className="h-3 w-3 mr-1" />
          Invited
        </Badge>
      );
    case 'invited_expired':
      return (
        <Badge className="bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100">
          <Clock className="h-3 w-3 mr-1" />
          Expired
        </Badge>
      );
    default:
      return (
        <Badge className="bg-slate-100 text-slate-600 border-slate-200 hover:bg-slate-100">
          <UserX className="h-3 w-3 mr-1" />
          Not Invited
        </Badge>
      );
  }
};
